import data from '../../components/common/modules/v3/brand/dummyData';

export default data;